import { Edit } from '@carbon/icons-react';
import { useTheme } from '@repo/theme';
import { VertBox } from 'component/basics';
import { FunctionalModal } from 'component/modal/functional-modal';
import { UtilityText } from 'component/text';
import { t } from 'util/stdtypes';

export type TakeSecondLookModalProps = {
    isNewComment: boolean;
    onConfirm: () => void;
    onClose: () => void;
};

export function TakeSecondLookModal({ isNewComment, onConfirm, onClose }: TakeSecondLookModalProps) {
    const { colors } = useTheme();
    return (
        <FunctionalModal
            headingLabel={t('moderation.take_second_look_title', 'Take a second look')}
            onClose={onClose}
            primaryButton={{
                label: isNewComment
                    ? t('moderation.post_without_editing_button', 'Post without editing')
                    : t('moderation.update_without_editing_button', 'Update without editing'),
                onPress: onConfirm,
                testID: 'post-without-editing',
            }}
            secondaryButton={{
                label: t('moderation.edit_your_post_button', 'Edit your post'),
                onPress: onClose,
                icon: <Edit color={colors.colorTextPrimary} />,
                testID: 'edit-your-post',
            }}
            subheadingContent={
                <VertBox gap={16} wide>
                    <UtilityText
                        color={colors.colorTextSecondary}
                        label={t(
                            'moderation.take_second_look_warning',
                            '❗️ Our AI review suggests your response may turn people away who do not share your point of view.',
                        )}
                        type='large'
                    />
                    <UtilityText
                        color={colors.colorTextSecondary}
                        label={t(
                            'moderation.take_second_look_rephrase',
                            '📢 Consider rephrasing your message to reach a wider audience and spark more meaningful discussions.',
                        )}
                        type='large'
                    />
                </VertBox>
            }
        />
    );
}
